<div class="add-button-wrapper">
  <button class="add-button-text" (click)="onAddProduct(servicesButtons)">
    {{ 'Sellers.Products.AddProduct' | translate }}
  </button>
  <button (click)="onAddProduct(servicesButtons)" id="addButton" class="add-button">+</button>
</div>

<div #servicesButtons id="services" class="services row">
  <button routerLink="/seller/new-products/invoice" class="service col-auto my-2">
    {{ 'Sellers.Products.Invoice' | translate }}
  </button>
  <button routerLink="/seller/new-products/event" class="service col-auto my-2">
    {{ 'Sellers.Products.Event' | translate }}
  </button>
  <button routerLink="/seller/new-products/reservation" class="service col-auto my-2">
    {{ 'Sellers.Products.Reservation' | translate }}
  </button>
  <button routerLink="/seller/new-products/physical" class="service col-auto my-2">
    {{ 'Sellers.Products.Product' | translate }}
  </button>
  <button *ngIf="isSellerHasQuickPayment" routerLink="/seller/new-products/quick-cash" class="service col-auto my-2">
    {{ 'Sellers.Products.QuickCash' | translate }}
  </button>
  <button routerLink="/seller/new-products/subscription" class="service col-auto my-2">
    {{ 'Sellers.Products.Subscription' | translate }}
  </button>
  <button *ngIf="isSellerHasQuickQassatly" routerLink="/seller/new-products/quick-qassatly" class="service col-auto my-2">
    {{ 'Sellers.Products.QuickQassatly' | translate }}
  </button>
  <button *ngIf="isSellerHasQuickPayment" routerLink="/seller/new-products/quick-payment" class="service col-auto my-2">
    {{ 'Sellers.Products.QuickPayment' | translate }}
  </button>
  <button routerLink="/seller/new-products/calendar" class="service col-auto my-2">
    {{ 'Sellers.Products.Calendar' | translate }}
  </button>
</div>
